import React from "react";
import DashboardScreen from "../screens/DashboardScreen";


const DashboardContainer = (props) => {
  const user = JSON.parse(localStorage.getItem("@jarvis/user"));

  return <DashboardScreen user={user} />;
};


export default DashboardContainer;
